/**
 * The `hasMore` label is only correct when the server returns one page at a time.
 * With internal pagination `rows` holds the whole dataset, so the row count says
 * nothing about the current page.
 */
export function resolveHasMore(options: {
  externalPagination?: boolean;
  totalRows?: number;
  hasMore?: boolean;
}): boolean | undefined {
  if (!options.externalPagination || options.totalRows != null) {
    return undefined;
  }

  return options.hasMore;
}

export function formatDisplayedRows(options: {
  page: number;
  pageSize: number;
  rowCount: number;
  totalRows: number;
  hasMore?: boolean;
}): string {
  const start = (options.page - 1) * options.pageSize + 1;

  if (options.hasMore != null) {
    if (options.rowCount === 0) {
      return '0-0';
    }

    return `${start}-${start + options.rowCount - 1}`;
  }

  return `${start}-${Math.min(options.page * options.pageSize, options.totalRows)} of ${options.totalRows}`;
}

export function paginationTotalForHasMore(options: {
  page: number;
  pageSize: number;
  rowCount: number;
  hasMore: boolean;
}): number {
  return (options.page - 1) * options.pageSize + options.rowCount + (options.hasMore ? 1 : 0);
}
